const validValues = obj => Object.values(obj).every(elem => elem);

export default validValues;
